import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { format, addDays } from "date-fns";
import Select from "react-select";
import { formatDate } from "../utils/utilityfunc";
import DateRanger from "./components-react/DateRanger";
import { selectAuth } from "./auth/auth.selector";

const FilterBlock = ({
  allFilters = [],
  isSearch,
  isDate,
  setFilters,
  isDateRanger,
  // dateFilters,
  // setDateFilters,
}) => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  const isAdmin = user?.account_type === "admin";

  const [saveFilters, setSaveFilters] = useState({});
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const { dateFilters, setDateFilters } = isDateRanger || {};

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setDateFilters({
      start_date: formattedStartDate,
      end_date: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setDateFilters({
      start_date: "",
      end_date: "",
    });
  };

  const onApply = () => {
    try {
      const newFilters = {
        gym_id: !isAdmin ? user?.gym_id || user?.uid || user?.user_id : "",
      };
      const oldFilters = { ...saveFilters };
      Object.keys(oldFilters).forEach((key) => {
        if (key === isDate?.key) {
          return (newFilters[key] = formatDate(
            oldFilters[key],
            isDate?.format
          ));
        }
        newFilters[key] = oldFilters[key]?.value;
      });
      setFilters &&
        setFilters({
          ...newFilters,
          start_date: dateFilters?.start_date || "",
          end_date: dateFilters?.end_date,
        });
    } catch (error) {
      console.error(error);
    }
  };

  const onReset = () => {
    try {
      if (isDate && isDate.handleChange) {
        isDate.handleChange("");
      }
      if (isDateRanger) {
        setOpenDateRanger(false);
        setRangeState(initialRangeState);
        setDateFilters({
          start_date: "",
          end_date: "",
        });
      }

      setSaveFilters({});
      setFilters({
        gym_id: !isAdmin ? user?.gym_id || user?.uid || user?.user_id : "",
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (name, opt) => {
    try {
      setSaveFilters({
        ...saveFilters,
        [name]: opt,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="grid-k max-w-full-k dark-bg-k p-3 rounded-2 grid-auto-col-k gap-1-k">
      {openDateRanger && (
        <div className="openedDateRanger">
          <DateRanger
            handleDateRangeChange={handleDateRangeChange}
            rangeState={rangeState}
            onClose={() => setOpenDateRanger(false)}
            onClear={clearDateRanger}
          />
        </div>
      )}

      {isSearch && (
        <div className="flex-k flex-col-k">
          <label htmlFor="search">Search</label>
          <input
            type="text"
            id="search"
            className="input-k"
            placeholder={isSearch?.placeholder}
            value={saveFilters?.search?.value || ""}
            onChange={(e) =>
              handleChange(e?.target?.id, { value: e?.target?.value })
            }
          />
        </div>
      )}

      {isDate && (
        <div className="flex-k flex-col-k">
          <label htmlFor="date">Date</label>
          <input
            type="date"
            id={`${isDate?.key}`}
            className="input-k"
            value={isDate.dateFilter}
            onChange={(e) => isDate.handleChange(e.target?.value)}
          />
        </div>
      )}

      {isDateRanger && (
        <div className="flex-k flex-col-k filterBlockDateRanger">
          <label htmlFor="dateRanger">Date</label>
          <div
            className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper`}
          >
            {openDateRanger ? (
              <div className="closeAndClearDateRangerButtons">
                <button
                  className="notmalButtonStyles noStyle closeRangerBtn"
                  onClick={() => setOpenDateRanger(false)}
                  style={{ textAlign: "center" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                  </svg>
                  Close
                </button>
                <button
                  className="notmalButtonStyles noStyle clearRangerBtn"
                  onClick={clearDateRanger}
                  style={{ textAlign: "center" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                  Clear
                </button>
              </div>
            ) : dateFilters.start_date || dateFilters.end_date ? (
              <button
                type="button"
                className="notmalButtonStyles"
                style={{ textAlign: "center" }}
                onClick={() => setOpenDateRanger(true)}
              >
                <span className="dates">
                  {moment(dateFilters.start_date).format("DD-MM-YYYY")}
                </span>
                {"  "}
                TO{"  "}
                <span className="dates">
                  {moment(dateFilters.end_date).format("DD-MM-YYYY")}
                </span>
              </button>
            ) : (
              <button
                type="button"
                className="notmalButtonStyles"
                onClick={() => setOpenDateRanger(true)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                Select Date
                <span className="icon calender">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_13711_4583)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.7494 5.25113V6.00038C12.7396 6.47963 12.2124 6.86888 11.7519 6.70688C11.4616 6.60488 11.2576 6.31088 11.2509 6.00038V5.25113H9.00386C8.42036 5.22338 8.03861 4.47263 8.43761 4.01138C8.54711 3.88538 8.69786 3.79838 8.86211 3.76688C8.92436 3.75488 8.94086 3.75638 9.00386 3.75338H11.2509V3.00413C11.2539 2.88188 11.2651 2.84213 11.2884 2.77013C11.3881 2.46863 11.6949 2.25488 12.0151 2.25488C12.4119 2.27063 12.7404 2.56988 12.7494 3.00413V3.75338H17.2434V3.00413C17.2464 2.88188 17.2576 2.84213 17.2809 2.77013C17.3806 2.46863 17.6874 2.25488 18.0076 2.25488C18.4044 2.27063 18.7329 2.56988 18.7419 3.00413V3.75338H19.4934C19.5196 3.75338 19.5196 3.75338 19.5466 3.75413C20.6941 3.78938 21.7156 4.77713 21.7381 5.97263C21.7651 10.4771 21.7381 14.9816 21.7381 19.4854C21.7306 20.6471 20.7444 21.7076 19.5189 21.7301C14.5149 21.7609 9.51086 21.7309 4.50761 21.7309C3.33911 21.7234 2.28536 20.7191 2.26286 19.5116C2.23436 15.0071 2.26211 10.5026 2.26211 5.99813C2.26961 4.82663 3.28361 3.76088 4.50761 3.75338H5.25836V3.00413C5.26136 2.88188 5.27261 2.84213 5.29586 2.77013C5.39561 2.46863 5.70236 2.25488 6.02261 2.25488C6.14411 2.26013 6.18461 2.27213 6.25586 2.29763C6.54611 2.39963 6.75086 2.69363 6.75686 3.00413V6.00038C6.74711 6.47963 6.21986 6.86888 5.75936 6.70688C5.46911 6.60488 5.26511 6.31088 5.25836 6.00038V5.25038C5.00561 5.24963 4.75286 5.24963 4.50011 5.25113C4.11311 5.25863 3.76811 5.59988 3.76061 5.99138C3.73286 10.4914 3.73286 14.9921 3.76061 19.4929C3.76811 19.8806 4.10861 20.2249 4.50011 20.2324C9.50036 20.2631 14.5006 20.2631 19.5001 20.2324C19.8879 20.2249 20.2321 19.8844 20.2396 19.4929C20.2674 14.9921 20.2674 10.4914 20.2396 5.99063C20.2329 5.60213 19.8969 5.25413 19.4881 5.25113H18.7419V6.00038C18.7306 6.55163 18.0061 6.95663 17.5359 6.59363C17.3544 6.45413 17.2479 6.23138 17.2434 6.00038V5.25113H12.7494ZM6.00761 17.2361C6.42086 17.2361 6.75686 17.5721 6.75686 17.9854C6.75686 18.3986 6.42086 18.7346 6.00761 18.7346C5.59436 18.7346 5.25836 18.3986 5.25836 17.9854C5.25836 17.5721 5.59436 17.2361 6.00761 17.2361ZM9.00386 17.2361C9.41711 17.2361 9.75311 17.5721 9.75311 17.9854C9.75311 18.3986 9.41711 18.7346 9.00386 18.7346C8.59061 18.7346 8.25461 18.3986 8.25461 17.9854C8.25461 17.5721 8.59061 17.2361 9.00386 17.2361ZM12.0001 17.2361C12.4134 17.2361 12.7494 17.5721 12.7494 17.9854C12.7494 18.3986 12.4134 18.7346 12.0001 18.7346C11.5869 18.7346 11.2509 18.3986 11.2509 17.9854C11.2509 17.5721 11.5869 17.2361 12.0001 17.2361ZM6.00761 14.2399C6.42086 14.2399 6.75686 14.5759 6.75686 14.9891C6.75686 15.4024 6.42086 15.7384 6.00761 15.7384C5.59436 15.7384 5.25836 15.4024 5.25836 14.9891C5.25836 14.5759 5.59436 14.2399 6.00761 14.2399ZM9.00386 14.2399C9.41711 14.2399 9.75311 14.5759 9.75311 14.9891C9.75311 15.4024 9.41711 15.7384 9.00386 15.7384C8.59061 15.7384 8.25461 15.4024 8.25461 14.9891C8.25461 14.5759 8.59061 14.2399 9.00386 14.2399ZM12.0001 14.2399C12.4134 14.2399 12.7494 14.5759 12.7494 14.9891C12.7494 15.4024 12.4134 15.7384 12.0001 15.7384C11.5869 15.7384 11.2509 15.4024 11.2509 14.9891C11.2509 14.5759 11.5869 14.2399 12.0001 14.2399ZM14.9964 14.2399C15.4096 14.2399 15.7456 14.5759 15.7456 14.9891C15.7456 15.4024 15.4096 15.7384 14.9964 15.7384C14.5831 15.7384 14.2471 15.4024 14.2471 14.9891C14.2471 14.5759 14.5831 14.2399 14.9964 14.2399ZM17.9926 14.2399C18.4059 14.2399 18.7419 14.5759 18.7419 14.9891C18.7419 15.4024 18.4059 15.7384 17.9926 15.7384C17.5794 15.7384 17.2434 15.4024 17.2434 14.9891C17.2434 14.5759 17.5794 14.2399 17.9926 14.2399ZM9.00386 11.2436C9.41711 11.2436 9.75311 11.5796 9.75311 11.9929C9.75311 12.4061 9.41711 12.7421 9.00386 12.7421C8.59061 12.7421 8.25461 12.4061 8.25461 11.9929C8.25461 11.5796 8.59061 11.2436 9.00386 11.2436ZM12.0001 11.2436C12.4134 11.2436 12.7494 11.5796 12.7494 11.9929C12.7494 12.4061 12.4134 12.7421 12.0001 12.7421C11.5869 12.7421 11.2509 12.4061 11.2509 11.9929C11.2509 11.5796 11.5869 11.2436 12.0001 11.2436ZM14.9964 11.2436C15.4096 11.2436 15.7456 11.5796 15.7456 11.9929C15.7456 12.4061 15.4096 12.7421 14.9964 12.7421C14.5831 12.7421 14.2471 12.4061 14.2471 11.9929C14.2471 11.5796 14.5831 11.2436 14.9964 11.2436ZM17.9926 11.2436C18.4059 11.2436 18.7419 11.5796 18.7419 11.9929C18.7419 12.4061 18.4059 12.7421 17.9926 12.7421C17.5794 12.7421 17.2434 12.4061 17.2434 11.9929C17.2434 11.5796 17.5794 11.2436 17.9926 11.2436Z"
                        fill="#898989"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13711_4583">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </button>
            )}
          </div>
        </div>
      )}

      {allFilters.map((filterDetails) => {
        return (
          <React.Fragment key={filterDetails.id}>
            {!isAdmin && filterDetails?.name === "gym_id" ? null : (
              <div className="w-full-k">
                <label htmlFor={filterDetails.id}>{filterDetails.label}</label>
                <div className="dark-text">
                  {filterDetails.elemnt ? (
                    filterDetails.elemnt
                  ) : (
                    <Select
                      options={filterDetails.options}
                      isClearable
                      placeholder={`Select ${filterDetails.label}`}
                      classNamePrefix={"input-k-select"}
                      value={saveFilters[filterDetails.name] || null}
                      id={filterDetails.id}
                      onChange={(opt) => handleChange(filterDetails.name, opt)}
                      // Render the menu in a body-level portal so it overlays the
                      // table below instead of being clipped/overlapped by it.
                      menuPortalTarget={
                        typeof document !== "undefined" ? document.body : null
                      }
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </React.Fragment>
        );
      })}

      <div className="flex-k items-end-k grid-span-2-k gap-1-k w-full-k">
        <button className="btn-k w-full-k btn-primary-k" onClick={onApply}>
          Apply Filters
        </button>
        <button className="btn-k w-full-k btn-primary-k" onClick={onReset}>
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default FilterBlock;
